// Group raw MT5 executions into COMPLETED trades by position_id + deal entry.
// An opening/entry-only deal (e.g. +0 profit) is NOT a completed trade.
// Partial closes on the same position aggregate into one trade. Realized P&L is
// preserved (profit + commission + swap + fee). Mirrors backend _completed_trades.
const _num = (v) => (typeof v === "number" ? v : v ? Number(v) : 0) || 0;
const _isClose = (e) => {
  if (e === null || e === undefined) return false;
  return ["1", "2", "3", "out", "inout", "out_by"].includes(String(e).trim().toLowerCase());
};

export function groupCompletedTrades(deals = []) {
  const groups = {};
  deals.forEach((t) => {
    const key = t.position_id || t.mt5_ticket;
    const g = groups[key] || (groups[key] = { key, realized: 0, grossProfit: 0, costs: 0, symbol: t.symbol, side: null, volume: 0, ts: null, openTs: null, time: null, openTime: null, count: 0, hasClose: false, entryKnown: false });
    g.grossProfit += _num(t.profit);
    g.costs += _num(t.commission) + _num(t.swap) + _num(t.fee);
    g.realized += _num(t.profit) + _num(t.commission) + _num(t.swap) + _num(t.fee);
    g.count += 1;
    if (!g.symbol) g.symbol = t.symbol;
    const e = t.entry;
    const known = e !== null && e !== undefined && String(e).trim() !== "";
    if (known) { g.entryKnown = true; if (_isClose(e)) g.hasClose = true; }
    if (g.side === null && known && !_isClose(e)) g.side = t.trade_type; // direction from opening deal
    if (_isClose(e)) g.volume += _num(t.volume);
    const ts = t.trade_ts != null ? t.trade_ts : null;
    if (ts != null) {
      g.ts = g.ts == null ? ts : Math.max(g.ts, ts);
      g.openTs = g.openTs == null ? ts : Math.min(g.openTs, ts);
    }
    if (t.trade_time) g.time = t.trade_time;
    if (t.trade_time && (g.openTime == null || (ts != null && ts === g.openTs))) g.openTime = t.trade_time;
  });
  return Object.values(groups)
    .filter((g) => g.hasClose || (!g.entryKnown && g.realized !== 0))
    .map((g) => ({ ...g, realized: Math.round(g.realized * 100) / 100, grossProfit: Math.round(g.grossProfit * 100) / 100, costs: Math.round(g.costs * 100) / 100, side: g.side == null ? 0 : g.side, volume: g.volume || null }))
    .sort((a, b) => (b.ts || 0) - (a.ts || 0));
}
